if (!customElements.get('size-chart-content')) {
  customElements.define('size-chart-content',
    class SizeChartContent extends HTMLElement {
      constructor() {
        super();

        this.originalTable = this.querySelector('table');
        this.variantControls = document.querySelector('product-info variant-radios') || document.querySelector('product-info variant-selects');
      }

      connectedCallback() {
        if (!this.originalTable) return;
        this.transposeTable();
        // this.highlightCells(this.variantControls.querySelector('input:checked').value);
      }

      transposeTable() {
        this.originalTable.id = 'size-chart-desktop';

        const newTable = document.createElement('table');
        newTable.id = 'size-chart-mobile';
        const rows = this.originalTable.rows;
        const rowData = Array.from(rows).map(row => Array.from(row.cells).map(cell => cell.innerText));

        const newHeaderRow = newTable.insertRow();
        for (let i = 0; i < rows.length; i++) {
          const newHeaderCell = document.createElement('th');
          newHeaderCell.innerText = i === 0 ? 'Size' : rowData[i][0];
          newHeaderRow.appendChild(newHeaderCell);
        }

        for (let i = 1; i < rows[0].cells.length; i++) {
          const newRow = newTable.insertRow();
          const newHeaderCell = document.createElement('th');
          newHeaderCell.innerText = rows[0].cells[i].innerText;
          newRow.appendChild(newHeaderCell);

          for (let j = 1; j < rows.length; j++) {
            const newCell = newRow.insertCell();
            newCell.innerText = rowData[j][i];
          }
        }

        this.originalTable.parentNode.append(newTable);
      }

      highlightCells(value) {
        this.querySelectorAll('[data-highlighted]').forEach(td => {
          td.removeAttribute('data-highlighted');
        });

        const desktopColumns = this.querySelectorAll('#size-chart-desktop tr:first-of-type td');
        let targetIndex = -1;

        desktopColumns.forEach((td, index) => {
          if (td.textContent.trim() === value) {
            targetIndex = index + 1;
          }
        });

        if (targetIndex !== -1) {
          const cellsToHighlight = this.querySelectorAll(`#size-chart-desktop tr td:nth-child(${targetIndex}), #size-chart-mobile tr:nth-child(${targetIndex}) td, #size-chart-mobile tr:nth-child(${targetIndex}) th`);
          cellsToHighlight.forEach(cell => {
            cell.setAttribute('data-highlighted', '');
          });
        }
      }
    }
  );
}